// extracted by mini-css-extract-plugin
export default {"pie-data-container":"style_pie-data-container__XP+3L"};